import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Card, Chip, Stack } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import formatString from '@utils/formatString';
import { useCallback, useMemo, useState } from 'react';

function CodebookDetailsView({
  interviewCodebook,
  setSelectedCode,
  handleChipClick,
  getColorByCategory,
}) {
  const [expandedCategories, setExpandedCategories] = useState(new Set());

  const toggleCategory = useCallback((categoryKey) => {
    setExpandedCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(categoryKey)) {
        newSet.delete(categoryKey);
      } else {
        newSet.add(categoryKey);
      }
      return newSet;
    });
  }, []);
  const sortedData = useMemo(() => {
    if (!interviewCodebook?.categories) return {};

    return Object.fromEntries(
      Object.entries(interviewCodebook.categories).sort(([, a], [, b]) => b.saliency - a.saliency),
    );
  }, [interviewCodebook?.categories]);
  return (
    <Card sx={{ padding: 2, borderRadius: 1, marginBottom: '100px' }} variant="outlined">
      {Object.entries(sortedData || {}).map(([categoryKey, categoryData], index) => (
        <Accordion
          elevation={0}
          sx={{ boxShadow: 'none' }}
          defaultExpanded={index === 0 ? true : false}
          key={index}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography
              component="span"
              sx={{ fontWeight: '700', fontSize: '16px' }}
            >{`${formatString(categoryKey)} (n=${categoryData.saliency})`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {' '}
              <span style={{ fontWeight: '600' }}>Description : </span>
              {categoryData.description}
            </Typography>
            {categoryData?.summary && (
              <Typography mt={1}>
                {' '}
                <span style={{ fontWeight: '600' }}>Summary : </span>
                {categoryData?.summary}
              </Typography>
            )}
            <Typography>
              {' '}
              <span style={{ fontWeight: '600' }}>Saliency : </span>
              {categoryData.saliency}
            </Typography>

            <Typography fontWeight={'600'} mt={1}>
              Codes :
            </Typography>
            <Stack direction="row" flexWrap="wrap" sx={{ rowGap: 1, columnGap: 1, mt: '5px' }}>
              {(expandedCategories.has(categoryKey)
                ? categoryData.codes_included
                : categoryData.codes_included.slice(0, 16)
              ).map((code, i) => (
                <Chip
                  key={i}
                  label={formatString(code)}
                  size="small"
                  sx={{
                    borderRadius: '4px',
                    backgroundColor: getColorByCategory(categoryKey),
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChipClick(code);
                    setSelectedCode({
                      name: code,
                      definition: categoryData.description,
                      location: 0,
                      saliency: categoryData.saliency,
                      categoryKey,
                    });
                  }}
                />
              ))}

              {/* See More / See Less Toggle */}
              {categoryData.codes_included.length > 16 && (
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 600,
                    cursor: 'pointer',
                    color: '#7d5ae8',
                    marginLeft: '10px',
                  }}
                  onClick={() => toggleCategory(categoryKey)}
                >
                  {expandedCategories.has(categoryKey) ? 'See Less' : 'See More'}
                </Typography>
              )}
            </Stack>
            <Typography fontWeight={'600'} mt={1}>
              Example Quotes :
            </Typography>
            <Stack spacing={1} mt={0.5}>
              {categoryData.example_quotes?.map((quote, i) => (
                <Typography variant="body2" sx={{ fontStyle: 'italic' }} key={i}>
                  {quote.text}
                </Typography>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}
    </Card>
  );
}

export default CodebookDetailsView;
